import './card.style.sass';
import template from './card.tpl.pug';

export default {
    selector: 'dbADashboardCard',
    template: template(),
    transclude: {
        date: 'cardDate',
        content: 'cardContent'
    },
    bindings: {
        name: '@'
    }
};



// WEBPACK FOOTER //
// ./src/application/scene/authorized/scene/dashboard/component/card/card.cmpt.js